// extracted by mini-css-extract-plugin
export default {"quickLinkBtn":"quick-link-chips_quickLinkBtn__4MTfi","btnIcons":"quick-link-chips_btnIcons__I0RlZ","removeIcon":"quick-link-chips_removeIcon__WyTCg"};